export enum ReductionTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT'
}

export const reductionTypeEnumMapping: Record<ReductionTypeEnum, string> = {
  [ReductionTypeEnum.PERCENTAGE]: 'Pourcentage',
  [ReductionTypeEnum.AMOUNT]: 'Montant fixe'
}
